import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=324a0fa8&scoped=true&"
import script from "./UserTransactions.vue?vue&type=script&lang=js&"
export * from "./UserTransactions.vue?vue&type=script&lang=js&"
import style0 from "./UserTransactions.vue?vue&type=style&index=0&id=324a0fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a0fa8",
  null
  
)

export default component.exports